module.exports = __webpack_public_path__ + "static/img/dynamic.79ed5b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/dynamic.png
// module id = cvdq
// module chunks = 1